import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";
import { api } from "../api/api"; 

let app = null;
let messaging = null;
let vapidKey = null;
let initPromise = null; 

export const initFirebase = async () => {
    if (app) return { messaging, vapidKey, config: app.options };
    
    if (initPromise) return initPromise; 

    initPromise = (async () => {
        try {
            const { data } = await api.get("/config/firebase");

            app = initializeApp({
                apiKey: data.apiKey,
                authDomain: data.authDomain,
                projectId: data.projectId,
                storageBucket: data.storageBucket,
                messagingSenderId: data.messagingSenderId,
                appId: data.appId,
                measurementId: data.measurementId
            });

            messaging = getMessaging(app);
            vapidKey = data.vapidKey;

            return { messaging, vapidKey, config: data };
        } catch (error) {
            console.error("Failed to initialize Firebase:", error);
            throw error;
        }
    })();

    return initPromise;
};